import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import { BmmEnvironmentBanner } from "./components/BmmEnvironmentBanner.js";
import { registerErrorReporting } from "./observability.js";
import "./styles.css";

// Before the first render, so a crash on mount is captured. Inert without VITE_SENTRY_DSN.
registerErrorReporting();

const root = document.getElementById("root");
if (!root) throw new Error("index.html is missing #root");

createRoot(root).render(
  <StrictMode>
    <BmmEnvironmentBanner environment={import.meta.env.VITE_DEPLOYMENT_ENVIRONMENT} />
    <App />
  </StrictMode>,
);
